/* eslint-disable max-len */
import previewImage1 from './images/preview-1.jpg'
import previewImage2 from './images/preview-2.jpg'
import previewImage3 from './images/preview-3.jpg'


export type Video = {
  url: string
  preview: string
  name: string
}

const videos: Video[] = [
  {
    url: 'https://player.vimeo.com/progressive_redirect/playback/848793820/rendition/1080p/file.mp4?loc=external&signature=92f58a390130185a64731949ba6e9a158ffd5e52bf50a5b1f1f9fa26e2f82e24',
    preview: previewImage1,
    name: 'video1',
  },
  {
    url: 'https://player.vimeo.com/progressive_redirect/playback/848793786/rendition/1080p/file.mp4?loc=external&signature=09b7fb7f49b52264d27345810c183fae99be7f14511b2da05df4061c81e168b9',
    preview: previewImage2,
    name: 'video2',
  },
  {
    url: 'https://player.vimeo.com/progressive_redirect/playback/848793716/rendition/1080p/file.mp4?loc=external&signature=823e87f434fb2a43f3af4ae53d13cfcbe103ec2d3ca23fd81a50ffc641552cff',
    preview: previewImage3,
    name: 'video3',
  },
]

const useLandingBloggersVideos = () => {
  const firstVideoIndex = Math.floor(Math.random() * videos.length)
  const firstVideo = videos[firstVideoIndex]

  return {
    videos,
    firstVideoIndex,
    firstVideo,
  }
}


export default useLandingBloggersVideos
